module.exports = __webpack_public_path__ + "static/media/proposal_small.82f9eea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/gtmobile/src/proposal_small.png
// module id = 515
// module chunks = 0